import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../app/counterSlice'
import authReducer from '../app/authSlice'
import boardStudioReducer from '../app/boardStudioSlice'
import storeFrontReducer from '../app/storeFrontSlice'
import { livoxApi, cloudApi } from '../services/_livoxApi'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    boardStudio: boardStudioReducer,
    storeFront: storeFrontReducer,
    [livoxApi.reducerPath]: livoxApi.reducer,
    [cloudApi.reducerPath]: cloudApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(livoxApi.middleware, cloudApi.middleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
